import { render } from "./AlertW.vue?vue&type=template&id=4e8ad302&scoped=true"
import script from "./AlertW.vue?vue&type=script&lang=js"
export * from "./AlertW.vue?vue&type=script&lang=js"

import "./AlertW.vue?vue&type=style&index=0&id=4e8ad302&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8ad302"]])

export default __exports__